<template>
    <div>
        <page-header :title="$t('master.resetPassword')" />
        <h4 class="ion-text-start ion-padding-start">
            {{ $t('master.resetPasswordTitle') }}
        </h4>
        <text-box
            :label="$t('master.newPassword')"
            inputType="password"
            @onChange="handleNewPasswordChange"
            :error="errors['newPassword']"
        />
        <text-box
            :label="$t('master.confirmNewPassword')"
            inputType="password"
            @onChange="handleConfirmPasswordChange"
            :error="errors['passwordConfirmation']"
        />
        <ion-button v-if="!submitting" class="ion-float-start ion-padding-start ion-margin-top" @click="handleResetPassword">
            {{ $t('master.resetPassword') }}
        </ion-button>
        <ion-spinner v-else />
        <h3 v-if="success">{{ $t('master.resetPasswordSuccess') }}</h3>
    </div>
</template>

<script>
import TextBox from '@/components/TextBox.vue'
import PageHeader from '@/components/PageHeader'
import { validatePasswordReset } from '@/utils/validators.js'
import AxiosController from '@/controllers/AxiosController.js'
import { isMobile } from 'mobile-device-detect'

export default {
    name: 'ChangePassword',
    components: { TextBox, PageHeader },
    data() {
        return {
            newPassword: '',
            confirmPassword: '',
            errors: [],
            isMobile,
            success: false,
            submitting: false
        }
    },
    methods: {
        handleNewPasswordChange(value) {
            this.newPassword = value
        },
        handleConfirmPasswordChange(value) {
            this.confirmPassword = value
        },
        handleResetPassword() {
            this.errors = []

            const { error } = validatePasswordReset({
                newPassword: this.newPassword,
                passwordConfirmation: this.confirmPassword
            })
            if (error) {
                error.details.forEach(err => {
                    this.$set(this.errors, err.path[0], err.message)
                })
                return
            }
            this.submitting = true
            const params = {
                password: this.newPassword,
                token: this.$route.params.token
            }
            AxiosController.post('reset-password', params)
                .then(() => {
                    this.success = true
                    setTimeout(() => {
                        this.$router.push(this.isMobile ? '/login' : '/')
                    }, 3000)
                })
                .catch(({ error }) => {
                    this.$set(this.errors, 'oldPassword', error)
                    this.submitting = false
                })
        }
    }
}
</script>

<style>
ion-button {
    --border-radius: 20px;
}
</style>
